<script>
  import axios from 'axios';
  import Button from '@ui/pico/button.svelte';
  import Toggle from '@ui/pico/toggle.svelte';
  import { api, pages } from '../../config';
  import { goto } from '../../util';
  import { user } from '../../store';
  import { onMount } from 'svelte';

  let el;
  let terms = false;
  let website = '';
  $: siteParts = website?.split('.');
  $: websiteValid = siteParts.length > 1 && siteParts?.at(-1).length >= 2;
  $: buttonActive = websiteValid && terms;

  onMount(() => {
    el.focus();
  });

  async function addFirstSite() {
    const headers = {
      'content-type': 'application/json',
      'x-webforma-aid': $user.uid,
      'x-webforma-uid': $user.uid,
    };
    const body = { 
      domain: website,
      terms,
    };

    const response = await axios.post(api.sites.first.url, body, { headers });
    if (response.status < 400) {
      window.location = pages.dashboard.url;
    }
  }
  function backToAccount() {
    goto(pages.account.url);
  }
</script>

<dialog open>
  <article>
    <header>
      <a on:click|preventDefault={backToAccount} href="#close" aria-label="Close" class="close"
        >&nbsp;</a
      >
    </header>
    <form on:submit|preventDefault={addFirstSite}>
      <hgroup>
        <h2>Add a Site</h2>
        <h4>This site has no monthly cost ($0/month)</h4>
      </hgroup>

      <div class="grid">
        <div>
          <input bind:this={el} bind:value="{website}" required type="text" placeholder="yourwebsite.com" />
          <Toggle bind:value={terms} class="toggle secondary">
            I understand this is an alpha system and will use with caution.
          </Toggle>
        </div>
      </div>
      <Button
        disabled={!buttonActive}
        type="submit"
        class="{buttonActive ? 'primary' : 'secondary'}"
        iconLeft="upload-cloud"
        iconSize={32}>Purchase Site</Button
      >
    </form>
  </article>
</dialog>

<style>
  :global(.toggle) {
    --switch-checked-background-color: var(--primary);
  }
  article {
    width: 80vw;
    max-width: 700px;
  }
  article header {
    margin-bottom: 1em;
  }

  :global(button svg) {
    stroke-width: 1.6px;
  }
</style>
